import React from 'react';
import { SplitPaneTemplate } from 'components';
import { CtTag, CtDeclareContent, CtDeclareDetail } from 'containers';

import styles from './DeclareLayout.css';
import classNames from 'classnames/bind';
const cx = classNames.bind(styles);

const CtDeclareLayout = () => {
  return (
    <div className={cx('declareLayout-wrapper')}>
      <div className={cx('list-area')}>
        <CtTag noTagCount />
      </div>
      <div className={cx('content-area')}>
        <SplitPaneTemplate listData={<CtDeclareContent />} detail={<CtDeclareDetail />} />
      </div>
    </div>
  );
};

export default CtDeclareLayout;



// WEBPACK FOOTER //
// ./src/script/containers/declare/CtDeclareLayout.js